import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'eng-embed-layout',
  imports: [RouterOutlet],
  templateUrl: './embed-layout.component.html',
  styleUrl: './embed-layout.component.scss',
})
export class EmbedLayoutComponent {}
